import React from 'react';
import { Paper, Typography, Box, Alert, Divider } from '@mui/material';
import { Search as SearchIcon, People as PeopleIcon, Build as BuildIcon } from '@mui/icons-material';
import TagField from './TagField';

const AssetSearchMetadata = ({ asset, handleChange }) => {
  console.log('🔍 AssetSearchMetadata рендер');
  console.log('🏷️ Текущие теги:', asset.search_metadata?.tags);
  console.log('👥 Целевая аудитория:', asset.search_metadata?.target_audience);
  console.log('🎯 Сценарии использования:', asset.search_metadata?.use_cases);
  
  // Вспомогательная функция для обновления вложенных полей search_metadata
  const updateSearchMetadata = (field, value) => {
    console.log(`📝 Обновление search_metadata.${field}:`, value);
    const updatedMetadata = {
      ...asset.search_metadata,
      [field]: value
    };
    handleChange('search_metadata', updatedMetadata);
    console.log('✅ Обновленная search_metadata:', updatedMetadata);
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <SearchIcon sx={{ mr: 1, color: 'primary.main' }} />
        <Typography variant="h6" sx={{ fontWeight: 'bold', flexGrow: 1 }}>
          Поисковая оптимизация
        </Typography>
      </Box>
      <Divider sx={{ mb: 3 }} />
      <Alert severity="info" sx={{ mb: 3 }}>
        Эти данные помогают AI лучше находить и рекомендовать актив клиентам
      </Alert>
      <TagField
        label="Поисковые теги"
        placeholder="Добавьте любые теги: бренд, модель, категория, свойства..."
        value={asset.search_metadata?.tags || []}
        onChange={(newTags) => updateSearchMetadata('tags', newTags)}
        helperText="Все ключевые слова для поиска актива"
        icon={<SearchIcon />}
        maxTags={20}
        quickSuggestions={['Makita', 'Bosch', 'DeWalt', 'профессиональный', 'аккумуляторный', 'мощный', 'легкий', 'компактный', 'надежный']}
      />
      <TagField
        label="Целевая аудитория"
        placeholder="Кто будет использовать этот актив?"
        value={asset.search_metadata?.target_audience || []}
        onChange={(newTags) => updateSearchMetadata('target_audience', newTags)}
        helperText="Группы пользователей и клиенты"
        icon={<PeopleIcon />}
        maxTags={10}
        quickSuggestions={['строители', 'подрядчики', 'домашние мастера', 'event-агентства', 'частные лица', 'компании']}
      />
      <TagField
        label="Сценарии использования"
        placeholder="Для каких задач подходит актив?"
        value={asset.search_metadata?.use_cases || []}
        onChange={(newTags) => updateSearchMetadata('use_cases', newTags)}
        helperText="Области применения и задачи"
        icon={<BuildIcon />}
        maxTags={10}
        quickSuggestions={['ремонт', 'строительство', 'монтаж', 'мероприятия', 'фотосессии', 'переезд']}
      />
    </Paper>
  );
};

export default AssetSearchMetadata;
